import Toast from "components/toast";
import { _goToBack } from "routers/helper";

export const onAddAttributeRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  _goToBack();
};

export const onEditAttributeRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  _goToBack();
};

export const onDeleteAttributeRes = onEditAttributeRes;
